export const PAY = 'PAY';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
export const A_PRODUCT = 'A_PRODUCT';
export const BUY_CART = 'BUY_CART';
